<template>
    <div class="row">
        <help-modal/>
        <div class="col-xl-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('selecting_document_items_' + analyzeType) }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-001' : 'ASB-001'"/>
                    </div>
                </div>

                <div class="ibox-content">
                    <div class="row">
                        <div class="col-md-2">
                            <label>{{ __('date_type_analyze') }}</label>
                            <select2
                                :options="dateTypeAnalyzeOptions"
                                v-model="model.dateTypeAnalyze"
                                :settings="{ width: '90%' }"
                            />
                        </div>
                        <div class="col-md-2 ">
                            <label>{{ __("date_from_analyze") }}</label>
                            <datepicker
                                :options="dateFromOptions"
                                @change="handleDateFromChange()"
                                v-model="model.dateFrom"
                            >
                            </datepicker>
                        </div>
                        <div class="col-md-2 ">
                            <label>{{ __("date_to_analyze") }}</label>
                            <datepicker
                                :options="dateFromOptions"
                                @change="handleDateToChange()"
                                v-model="model.dateTo"
                            >
                            </datepicker>
                        </div>
                        <div class="col-md-2">
                            <label>{{ __('include_correction') }}</label>
                            <select2
                                :options="includeCorrectionOptions"
                                v-model="model.includeCorrectionAnalyze"
                                :settings="{ width: '90%' }"
                            />
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-primary centered-button" style="margin-top: 15px"
                                    @click="handleClickGetDocuments()">{{ __('download') }}
                            </button>
                        </div>
                        <div v-if="getDocumentsButtonClicked" class="col-md-2 text-center">
                            <div class="row no-margins" style="width:100%">
                                <!-- szukanie zabiera reszte miejsca, przycisk Filtry ma szerokosc tresci - przy
                                     powiekszeniu 125% col-3 bylo wezsze niz napis i tekst sie zawijal -->
                                <div class="input-group col p-l-0 p-r-5" style="margin-top: 15px">
                                    <input placeholder="Szukaj" type="text" v-model="searchValue"
                                           class="form-control form-control-sm" name="search">
                                    <span class="input-group-append">
                                            <button type="submit" class="btn btn-sm btn-primary search-button"
                                                    @click="handleFilter()" style="height: 30px !important;">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </span>
                                </div>

                                <button class="btn btn-primary btn-sm btn-filter text-center white-space-no-wrap p-l-5 p-r-5"
                                        type="button" style="margin-top: 15px;height: 30px !important;" @click="toggleFilterButton()">
                                    <span class="text-capitalize">{{ __('filters') }}&nbsp<i
                                        class="fas fa-sliders-h"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <global-analyze-filter v-if="showFilters"
                                           :globalFilters="globalFilters"
                                           :columnsSelected="columnsSelected"
                                           :documents="documents"
                                            @resetButtonClicked="resetButtonClicked()"
                                            @filterButtonClicked="filterButtonClicked()">

                    </global-analyze-filter>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
import HelpModal from "../../components/help/HelpModal";

export default {
    name: "ChoosePositionForAnalyze",
    components:{HelpModal},
    props: {
        analyzeType: {
            type: String
        },
        model: {
            type: Object
        },
        getDocumentsButtonClicked: {
            type: Boolean
        },
        showFilters: {
            type: Boolean
        },
        globalFilters: {
            type: Object
        },
        columnsSelected: {
            type: Array
        },
        documents: {
            type: Array
        }
    },
    data: function () {
        return {
            searchValue: null
        }
    },
    computed: {
        dateTypeAnalyzeOptions() {
            return [
                {text: this.__('date_issued'), 'id': 'date_issued'},
                {text: this.__('sale_date'), 'id': 'sale_date'}
            ]
        },
        includeCorrectionOptions() {
            return [
                {text: this.__('yes'), 'id': 1},
                {text: this.__('no_upper'), 'id': 0}
            ]
        },
        dateFromOptions() {
            return {
                todayBtn: "linked",
                format: "yyyy-mm-dd",
                todayHighlight: true,

            }
        }
    },
    methods: {
        resetButtonClicked(){
            this.$emit('resetButtonClicked');
        },
        handleClickGetDocuments() {
            this.$emit('getDocuments')
        },
        handleFilter() {
            this.$emit('filter', this.searchValue)
        },
        toggleFilterButton(){
            this.$emit('toggleFilterButton')
        },
        filterButtonClicked(){
            this.$emit('filter', this.searchValue)
        },
        handleDateFromChange(){
            if(this.model.dateFrom > this.model.dateTo){
                this.model.dateTo = this.model.dateFrom;
            }
        },
        handleDateToChange(){
            if(this.model.dateTo < this.model.dateFrom){
                this.model.dateFrom = this.model.dateTo;
            }
        }
    }
}
</script>

<style scoped>

</style>
